import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { tableMetricsAtom } from '../atoms';
import { dimensionMetricsSelector, globalOrderBySelector } from '@store/trends/base/selectors';
import { useDebounce } from 'react-use';
import ignoreRefetch from '@utils/metrics/ignoreRefetch';
import { METRICS_MAPPING } from '@utils';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { isAppModule } from '@utils/constants';

// build and manage local list of query metrics to reduce refetches
function useTableMetrics() {
  const metrics = useSelector(dimensionMetricsSelector);
  const selectedMetric = useSelector(selectedMetricSelector);
  const orderBy =
    useSelector(globalOrderBySelector) || METRICS_MAPPING[selectedMetric] || selectedMetric;

  const [tableMetrics, setTableMetrics] = useAtom(tableMetricsAtom);

  // debouce is required here as order by and metric changes are two different saga actions that happen together
  useDebounce(
    () => {
      const currentTableMetrics = [...metrics];
      if (!isAppModule) {
        /** TODO: why sort by metrics name? */
        currentTableMetrics.sort();
      }

      const { metrics: prevTableMetrics, orderBy: prevOrderBy }: any = tableMetrics;

      if (!ignoreRefetch(currentTableMetrics, prevTableMetrics) || orderBy !== prevOrderBy) {
        setTableMetrics({ metrics: currentTableMetrics, orderBy });
      }
    },
    100,
    [metrics, orderBy],
  );
}

export default useTableMetrics;
